import { SchoolType } from '@/types/schools';

const AVAILABLE_FILTERS = [
    'naam',
    'type',
    'schooladvies',
    'soortonderwijs',
    'stadsdeel',
    'denominatie',
    'onderwijsconcept',
    'inspectieoordeel',
	'ondersteuningsaanbod',
	'ondersteunings_subaanbod'
] as const;

export type AvailableFilter = typeof AVAILABLE_FILTERS[number];

type BaseFilterDistribution = {
    [key in SchoolType]?: AvailableFilter[];
}

type DefaultFilterDistribution = {
    default: AvailableFilter[];
    all?: AvailableFilter[];
}

type FilterDistribution = BaseFilterDistribution & DefaultFilterDistribution;

export function isAFilter(possibleFilter: string): possibleFilter is AvailableFilter {
    return (AVAILABLE_FILTERS as readonly string[]).includes(possibleFilter);
}

const poFilters: AvailableFilter[] = [
    'naam', 'onderwijsconcept', 'denominatie', 'inspectieoordeel', 'stadsdeel', 'type',
];

const voFilters: AvailableFilter[] = [
    'naam', 'onderwijsconcept', 'soortonderwijs', 'denominatie', 'inspectieoordeel',
    'stadsdeel', 'schooladvies', 'type', 'ondersteuningsaanbod',
	 'ondersteunings_subaanbod',
];

export const FILTER_DISTRIBUTION: FilterDistribution = {
    default: [
        'naam', 'onderwijsconcept', 'soortonderwijs', 'denominatie', 'inspectieoordeel',
        'stadsdeel', 'schooladvies', 'type', 'ondersteuningsaanbod', 'ondersteunings_subaanbod'
    ],
    // Basisonderwijs
    po: poFilters,
    sbo: poFilters,
    so: poFilters,
    // Voortgezet onderwijs
    vo: voFilters,
    vso: voFilters,
};
